class PlacementNote {
    id = null;
    user_id = null;
    placement_id = null;
    timestamp = null;
    note = '';

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default PlacementNote;
